import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import logo from "../../../../../Assets/images/logo.png";
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";
import { CheckIcon, EditCricleIcon } from "Assets/icons";
import ClientDetails from "components/shared/ReportComponents/ClientDetails";
import { useGetFeedbackStepDetailQuery, useSubmitFeedbackStepMutation } from "store/services/clients/assessmentTreatmentPlan";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import RenderQuestion, { RenderQuestionById } from "components/shared/ReportComponents/Questions/Index";
import { formatReportFeedback, reportInitialValues } from "helpers/assessment";
import { object } from "yup";
import { reportQuestionsValidationSchema } from "utils/validation/validationHelpers";
import { Formik } from "formik";
import { CLIENT_REPORT_TYPES, REPORT_IDS, TREATMENT_SUMMARY_REPORT_QUESTIONS } from "config/constants";
import AttachDocumentsReports from "components/shared/ReportComponents/AttachDocumentsReports";
import LoadingButton from "components/shared/LoadingButton";
import { TREATMENT_SUMMARY_REPORT_PREVIEW } from "config/paths";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import TreatmentSummaryGoalsReport from "components/shared/ReportComponents/TreatmentSummary/TreatmentSummaryGoalsReport";
import TherapistSignature from "components/shared/ReportComponents/TherapistSignature";
import ReportHeader from "components/shared/ReportComponents/ReportHeader/Index";
import { successMessageToast } from "helpers/common";
import { CSVLink } from "react-csv";
import ReportError from "../components/ReportError";

const TreatmentSummaryReport = () => {
  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();
  const [csvData, setCsvData] = useState([]);
  const csvLinkRef = useRef();

  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.TREATMENT_SUMMARY_REPORT].title);

  const [submitStep, { isLoading: submittingStep }] = useSubmitFeedbackStepMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetFeedbackStepDetailQuery({ assessmentId, clientId, clientType });
  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const caseloadId = data?.clientPendingCaseload?.id;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {

    const dataArray = [[
      "Title",
      "Context",
      "Discipline",
      // "Description",
      "Notes"]];

    data?.previousGoals?.map(item => dataArray.push([
      item?.assesmentGoalDetail?.title || "-",
      item?.assesmentGoalContext?.context || "-",
      item?.assesmentGoalDiscipline?.assign_term || "-",
      // item?.goal_description || "-",
      item?.goal_notes || "-",
    ]));

    setCsvData(dataArray);
  }, [data]);

  const handleDownloadCsv = () => {
    try {
      csvLinkRef.current.link.click();

    } catch (err) { console.log("Error creating csv") };
  };

  const initialValues = useMemo(() => {
    if (!data || !reportQuestions) return {};
    let answers = data?.assesmentData?.reportAnswers;
    let values = {
      documents: data?.assesmentData?.reportDocuments,
      resources: data?.assesmentData?.reportResources,
    };

    values = reportInitialValues(values, reportQuestions, answers);

    return values;
  }, [data, reportQuestions]);

  const validationSchema = useMemo(() => {
    if (!reportQuestions) return object();

    return reportQuestionsValidationSchema(reportQuestions);
  }, [reportQuestions])

  const handleSubmitStep = async (values) => {
    try {
      let payload = formatReportFeedback(reportHeading, reportQuestions, values);

      let response = await submitStep({
        assessmentAssignedId,
        data: payload,
        clientType
      });

      if (!response?.error) {
        navigate(generatePath(TREATMENT_SUMMARY_REPORT_PREVIEW, {
          assessmentId,
          clientId,
          clientType
        }));
      }

    } catch (err) {
      console.error("Error submitting step three", err);
    }
  };

  const renderQuestion = useCallback(
    (props) => (
      <RenderQuestionById
        reportQuestions={reportQuestions}
        {...props}
      />
    ),
    [reportQuestions]
  );
  return (
    <>
      <section className="ReportSec py-3 position-relative">
        <Container fluid>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmitStep}
            validationSchema={validationSchema}
            enableReinitialize
          >
            {({ handleSubmit, values, errors }) => (
              <Form onSubmit={handleSubmit}>
                {/* {console.log("values", values, errors)} */}
                {isLoading ? <LoadingIndicator /> : <Row>
                  <Col lg="12" className="my-2">
                    <div className="cardCstm p-lg-5 rounded-2 bg-white shadow">
                      <div className="top text-center position-relative">
                        <CSVLink
                          data={csvData}
                          ref={csvLinkRef}
                          style={{ display: "none" }}
                          filename={`${data?.firstname}_${data?.lastname}_${reportHeading}_review.csv`?.replace(/ /g, "_".toLocaleLowerCase())}
                        />
                        <Button
                          className="d-flex fw-bold position-absolute align-items-center justify-content-center commonBtn bg-transparent themeClr"
                          style={{ right: 0, top: 0 }}
                          onClick={handleDownloadCsv}
                        >
                          Download Review
                        </Button>
                      </div>
                      {isError ? (
                        <ErrorComponent />
                      ) : (
                        <>
                          {isFetching && <LoadingOverlay />}
                          <ReportHeader
                            initialHeading={data?.assesment?.report_heading || reportHeading}
                            therapistDetails={therapistDetails}
                            setHeading={setReportHeading}
                          />
                          <div className="formBody pt-3">
                            <div
                              className=""
                            >
                              <div className="py-3">
                                <div
                                  className="cardCstm rounded-2 px-3"
                                  style={{ background: "#F9F9F9" }}
                                >
                                  <ClientDetails
                                    data={data}
                                    showAssessmentDate={false}
                                  />
                                </div>
                              </div>
                              {reportQuestions?.length > 0 &&
                                reportQuestions?.map((question, index) => {
                                  if (
                                    [
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.notes,
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_clinical,
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_goals,
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.recommendation,
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary,
                                      TREATMENT_SUMMARY_REPORT_QUESTIONS.greeting
                                    ].includes(question.id)
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <div className="py-3">
                                      <RenderQuestion
                                        key={index}
                                        question={question}
                                        fieldName={question.id}
                                      />
                                    </div>
                                  );
                                }
                                )}
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary}
                                  reportQuestions={reportQuestions}
                                />
                                <TreatmentSummaryGoalsReport
                                  clientType={clientType}
                                  caseloadId={caseloadId}
                                  renderQuestion={renderQuestion}
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary}
                                  assessmentId={assessmentId}
                                />
                              </div>
                              {/* <div className="py-3">
                                <RenderQuestionById
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_goals}
                                  reportQuestions={reportQuestions}
                                />
                              </div> */}
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.summary_clinical}
                                  reportQuestions={reportQuestions}
                                />
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.recommendation}
                                  reportQuestions={reportQuestions}
                                />
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={TREATMENT_SUMMARY_REPORT_QUESTIONS.greeting}
                                  reportQuestions={reportQuestions}
                                  showQuestion={false}
                                />
                              </div>
                              <div className="py-3">
                                <AttachDocumentsReports
                                  acl={"private"}
                                  name="documents"
                                  allowedTypes={["pdf", "doc", "docx", "jpg", "xlsx", "png"]}
                                />
                              </div>
                            </div>
                            <div className="py-3">
                              <TherapistSignature
                                therapistDetails={therapistDetails}
                              />
                            </div>
                            <div className="py-3">
                              <KhanReportLogo />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <ReportError />
                    <LoadingButton
                      type="submit"
                      className="d-flex align-items-center justify-content-center commonBtn"
                      isLoading={submittingStep}
                    >
                      Preview
                    </LoadingButton>
                  </Col>
                </Row>}
              </Form>
            )}
          </Formik>
        </Container>
      </section>
    </>
  );
};



export default TreatmentSummaryReport;
